import Page from '@/common-utils/components/structure/page/Page';
import RouteUrls from '../enums/RouteUrls';
import UsersTable from '@/app/modules/users/monetic/components/tables/UsersTable';
import ICONS from '@/common-utils/enums/icons';
import ModalSendMailAddUser from '@/app/modules/users/monetic/components/modals/sendMailAddUser/ModalSendMailAddUser';
import { useState } from 'react';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import { nsUser } from '@/app/i18n/namespaces';
import useSessionStore from '@/app/store/session';
import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';

/**
 *
 * @returns {JSX} Users
 */
function Users() {

    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalSendMailAddUser, setShowModalSendMailAddUser] = useState(false);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.USERS}
                routeBase={RouteUrls.USERS}
            />
            <Page.Body dataCy='page-users'>
                <UsersTable
                    filtersEventName={setFiltersEventName('users')}
                    pageActions={
                        <PageActions actions={[
                            {
                                icon: ICONS.USER_ADD,
                                entity: 'actions.page.add_user',
                                namespace: nsUser,
                                onClick: () => setShowModalSendMailAddUser(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [
                                        Permissions.USER_CREATE.name
                                    ]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            }]}
                            retractable
                        />
                    } />
            </Page.Body>
            {
                showModalSendMailAddUser &&
                <ModalSendMailAddUser
                    isOpen={showModalSendMailAddUser}
                    setIsOpen={setShowModalSendMailAddUser}
                />
            }
        </Page>
    );
}

export default Users;